import Typography from '@mui/material/Typography';
import { styled } from '@mui/material';
import { GetTaskPoolQuery } from '../../../../gql/graphql';
import { TaskPoolProgress } from '../../../common/TaskPoolProgress';

interface PolicystreamQuoteSubmissionProgressProps {
    taskPool: NonNullable<GetTaskPoolQuery['getTaskPool']> | null | undefined;
}

export function PolicystreamQuoteSubmissionProgress({
    taskPool,
}: PolicystreamQuoteSubmissionProgressProps) {
    return (
        <Container>
            <Typography variant="h4" component="h1" gutterBottom>
                Submission in Progress
            </Typography>
            <Typography variant="body1" paragraph>
                Your submission is currently being processed. You can safely navigate away
                from this page and you will be notified when it's complete.
            </Typography>
            <TaskPoolProgress taskPool={taskPool} />
        </Container>
    );
}

const Container = styled('div')(({ theme }) => ({
    maxWidth: '60rem',
    margin: 'auto',
    padding: theme.spacing(4),
}));
